module.exports = __webpack_public_path__ + "img/custom_bg1.cafb06f1.png";